import { render, staticRenderFns } from "./VSyncTrigger.vue?vue&type=template&id=55025048&scoped=true"
import script from "./VSyncTrigger.vue?vue&type=script&lang=js"
export * from "./VSyncTrigger.vue?vue&type=script&lang=js"
import style0 from "./VSyncTrigger.vue?vue&type=style&index=0&id=55025048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55025048",
  null
  
)

export default component.exports